import Vue from 'vue'

export default {
	create({}, data){
		return Vue.api.post('inquiry/', {
			"user_id": data.user_id || null,
			"clinic_id": data.clinic_id || null,
			"worker_id": data.worker_id || null,
			"begin": data.begin || 0,
			"end": data.end || 0,
			"status": data.status || "declared",
			"description": data.description || ''
		})
	},
	update({}, inquiry) {
		return Vue.api.put('inquiry/' + inquiry._id, {
			"user_id": inquiry.user_id || null,
			"clinic_id": inquiry.clinic_id || null,
			"worker_id": inquiry.worker_id || null,
			"begin": inquiry.begin || null,
			"end": inquiry.end || null,
			"status": inquiry.status || null,
			"description": inquiry.description || ''
		})
	},
	byDate({}, filter) {
		return Vue.api.post('inquiry/date/list', filter)
	},
	list({}, filter) {
		return Vue.api.post('inquiry/list', {
			worker_id: filter.worker_id,
			clinic_id: filter.clinic_id,
            status: "declared",
			per_page: filter.per_page || 100
		}).then(list => {
			return list.data.filter(item => item.status === 'declared')
		})
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/inquiry/actions.js